module.exports = __webpack_public_path__ + "static/media/reward_icon.70c683eb.png";